import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getSettledList,
  editSettlement,
  getStatus,
} from "../../actions/settlementActions";
import DataGrid from "../../components/Datagrid";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";

const Settlements = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [statusOptions, setStatusOptions] = useState([]); // list from backend
  const [status, setStatus] = useState(""); // selected status

  // state for dialog
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  // const statusOptions = ["Pending", "Processing", "Completed", "Failed"];

  const redirect = (row) => {
    navigate(`/app/management/settlement-details`, { state: { row } });
  };

  const handleEditClick = (row) => {
    setSelectedRow(row);
    setStatus(row.settlementStatus || "");
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setStatus("");
  };

  const handleSave = () => {
    if (!selectedRow) return;

    const payload = { settlementId: selectedRow._id, status: status };
    dispatch(editSettlement(payload));
    // dispatch your update API call here
    // e.g., dispatch(updateSettlementStatus(selectedRow._id, status))

    // console.log("Saving for:", selectedRow._id, "New status:", status);

    handleCloseDialog();
  };

  ////////=======================================================================//////////
  const columns = [
    {
      field: "type",
      headerName: "Type",
      flex: 1,
    },
    {
      field: "settlementStatus",
      headerName: "Settlement Status",
      flex: 1,
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Tooltip title="View details">
            <Box
              sx={{ cursor: "pointer" }}
              onClick={() => redirect(params.row)}
            >
              <RemoveRedEyeRoundedIcon />
            </Box>
          </Tooltip>
          <Tooltip title="Edit settlement">
            <Box
              sx={{ cursor: "pointer" }}
              onClick={() => handleEditClick(params.row)}
            >
              <EditIcon />
            </Box>
          </Tooltip>
        </Box>
      ),
      flex: 1,
    },
  ];

  const businessInfo = useSelector((state) => state?.app?.businessInfo);
  const customerId = businessInfo?.customerId;
  const settlementList = useSelector(
    (state) => state?.settlement?.settlementList
  );

  useEffect(() => {
    if (customerId) {
      dispatch(getSettledList(customerId));
    }
  }, [customerId, dispatch]);

  ///update autocomplete list from backend api is not ready yet =========

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const result = await dispatch(getStatus());
        // assuming result is an array like ["Pending","Processing","Completed"]
        console.log("status result:", result);

        if (Array.isArray(result)) {
          setStatusOptions(result);
        }
      } catch (error) {
        console.error("Error fetching status:", error);
      }
    };

    fetchStatus();
  }, [dispatch]);

  return (
    <Box
      sx={{
        maxWidth: "100%",
        padding: 4,
        borderRadius: 2,
        margin: "auto",
        marginTop: 4,
        backgroundColor: "#fff",
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h3" color="textPrimary">
            Settlements
          </Typography>
        </Grid>

        <Grid item xs={12} sx={{ mt: 2 }}>
          <DataGrid
            col={columns}
            data={settlementList}
            getRowId={(row) => row?._id}
            name="settlement"
          />
        </Grid>
      </Grid>

      {/* Edit Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit Settlement</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <TextField
              label="Settlement ID"
              value={selectedRow?._id || ""}
              fullWidth
              disabled
              sx={{ mb: 3 }}
            />

            <Autocomplete
              options={statusOptions} // from backend
              value={status}
              onChange={(event, newValue) => setStatus(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Settlement Status" fullWidth />
              )}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleSave} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Settlements;
